import Icon from '../components/Icon.vue'

Icon.register({"user-plus":{"width":640,"height":512,"paths":[{"d":"M224 32C301.3 32 364 94.7 364 172S301.3 312 224 312 84 249.3 84 172 146.7 32 224 32zM384.4 324.1L322 308.5C256.4 355.6 177 345.1 126 308.5L63.6 324.1C26.2 333.4 0 367 0 405.6V438C0 461.2 18.8 480 42 480H406C429.2 480 448 461.2 448 438V405.6C448 367 421.8 333.4 384.4 324.1zM628 224.9H559.1V156C559.1 149.4 553.7 144 547.1 144H508.9C502.3 144 496.9 149.4 496.9 156L496.9 224.9 428 224.9C421.4 224.9 416 230.3 416 236.9V275.1C416 281.7 421.4 287.1 428 287.1L496.9 287.1 496.9 356C496.9 362.6 502.3 368 508.9 368H547.1C553.7 368 559.1 362.6 559.1 356L559.1 287.1 628 287.1C634.6 287.1 640 281.7 640 275.1V236.9C640 230.3 634.6 224.9 628 224.9z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/user-plus.js
// module id = null
// module chunks = 